"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var I18n = require("i18n-js");
var classNames = require("classnames");
var url_helpers_1 = require("../url_helpers");
var core_link_1 = require("./core_link");
function ModalSidebarListing(props) {
    var _a = React.useState(false), detailsVisible = _a[0], toggleDetails = _a[1];
    var renderThumbnail = function () {
        if (!props.listing.images) {
            return null;
        }
        return (React.createElement("div", { className: "modal-sidebar-listing__thumbnail" },
            React.createElement("img", { src: props.listing.images[0].source, alt: props.listing.title })));
    };
    if (props.loading || !props.listing) {
        return (React.createElement("div", { className: "modal-sidebar-listing modal-sidebar-listing--loading" },
            React.createElement("div", { className: "modal-sidebar-listing__thumbnail" }),
            React.createElement("div", { className: "modal-sidebar-listing__title" }),
            React.createElement("div", { className: "modal-sidebar-listing__details-label" }),
            React.createElement("div", { className: "modal-sidebar-listing__details" })));
    }
    return (React.createElement("div", { className: classNames('modal-sidebar-listing', { 'modal-sidebar-listing--expanded': detailsVisible }) },
        React.createElement("div", { className: "modal-sidebar-listing__primary" },
            renderThumbnail(),
            React.createElement("h2", { className: "modal-sidebar-listing__title" }, props.listing.title),
            React.createElement("button", { className: "modal-sidebar-listing__details-toggle", onClick: function () { return toggleDetails(!detailsVisible); } })),
        React.createElement("div", { className: "modal-sidebar-listing__secondary" },
            props.details && (React.createElement("dl", { className: "modal-sidebar-listing__details" }, props.details.map(function (detail) { return (React.createElement("div", { key: detail.term, className: "modal-sidebar-listing__detail" },
                React.createElement("dt", null, detail.term),
                React.createElement("dd", null, detail.definition))); }))),
            React.createElement(core_link_1.default, { to: url_helpers_1.ITEM_WITH_SLUG_ROUTE.expand({
                    slug: props.listing.slug,
                    id: props.listing.id
                }), className: "modal-sidebar-listing__link", target: "_blank" }, I18n.t('commons.offers.sidebar.viewListing')))));
}
exports.default = ModalSidebarListing;
//# sourceMappingURL=modal_sidebar_listing.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/modal_sidebar_listing.js
// module id = ceVs
// module chunks = 20 21